// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__mE12n"};